import type { AvailableFlightDatesResponseDto } from '../api/types';

export function mapAvailableDates(dto: AvailableFlightDatesResponseDto): DateIso[] {
    const { dates } = dto;

    return dates;
}
